import React, {useContext, useEffect, useState} from "react";
import DrawerContext from "../../../Context/DrawerContext";
import {useForm} from "react-hook-form";
import SnackbarContext from "../../../Context/SnackbarContext";
import {useSelector} from "react-redux";
import {Paper} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import CustomerForm from "../../../Components/Forms/Pages/CRM/Customer/CustomerForm";
import strings from "../../../localization";
import {addCustomer, getCustomers} from "../../../Services/CRM/CustomerService";

const formRules = {
    'firstName' : {required: true},
    'lastName' : {required: true},
}
const AddCustomer = (props) => {
    const auth = useSelector((state) => state.auth)
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
    });
    const {data, control, watch, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        setDrawerTitle(strings.pages.crm.customer.addCustomer.pageTitle);
    });

    const onSubmit = (data) => {
        addCustomer(data).then(response => {
            setShowLoader(true);

            if (!response || !response.ok){
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <CustomerForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                errors={errors}
                data={data}
                form={form}
                control={control}
                onSubmit={handleSubmit(onSubmit)}
                onCancel={() => onCancel()}
            />
        </Paper>
    </div>
}
export default AddCustomer;